import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoot from './App';
import reportWebVitals from './reportWebVitals';

// 导入Ant Design样式
import 'antd/dist/reset.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
